import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type ConfirmRecoveryCodeOperation = paths['/executor_web/recovery/confirm']['post'];

export type ConfirmRecoveryCodeRequestBody = NonNullable<
	NonNullable<ConfirmRecoveryCodeOperation['requestBody']>['content']['application/json']
>;
export interface ConfirmRecoveryCodeRequest extends ConfirmRecoveryCodeRequestBody {
	token: string;
}
export type ConfirmRecoveryCodeResponse =
	ConfirmRecoveryCodeOperation['responses'][200]['content']['application/json'];
export type ConfirmRecoveryCodeErrorResponse =
	| ConfirmRecoveryCodeOperation['responses'][400]['content']['application/json']
	| ConfirmRecoveryCodeOperation['responses'][401]['content']['application/json'];

/** POST `/executor_web/recovery/confirm` — см. `paths['/executor_web/recovery/confirm']` в auth swagger */
export function confirmRecoveryCode(request: ConfirmRecoveryCodeRequest, signal?: AbortSignal) {
	const {token, ...body} = request;

	return axiosInstance.post<ConfirmRecoveryCodeResponse>('recovery/confirm', body, {
		signal,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
